import type { HTMLAttributes } from 'react';
import styles from './Avatar.module.css';
import { cx } from '../../lib/cx';

export interface AvatarProps extends HTMLAttributes<HTMLDivElement> {
  initials?: string;
  src?: string;
  alt?: string;
  size?: 'sm' | 'md' | 'lg';
  shape?: 'round' | 'square';
  current?: boolean;
  brand?: boolean;
}

export function Avatar({
  initials,
  src,
  alt,
  size = 'md',
  shape = 'round',
  current,
  brand,
  className,
  ...rest
}: AvatarProps) {
  return (
    <div
      className={cx(
        styles.avatar,
        styles[size],
        shape === 'round' ? styles.round : styles.square,
        current && styles.current,
        brand && styles.brand,
        className,
      )}
      {...rest}
    >
      {src ? <img className={styles.img} src={src} alt={alt ?? ''} /> : (initials ?? '').slice(0, 2).toUpperCase()}
    </div>
  );
}
